import RewardLedgerView from "./RewardLedgerView";
import { fetchRewardLedger } from "../../store/loyaltySlices/rewardLedgerSlice";

export default function RewardLedger() {
    return (
        <RewardLedgerView
            title="Reward Ledger"
            subtitle="All credits and debits of reward points."
            stateKey="ledger"
            fetchAction={fetchRewardLedger}
        />
    );
}